module.exports = __webpack_public_path__ + "static/img/5.0878474.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/afterSale/5.jpg
// module id = r6DQ
// module chunks = 1